import { Box, Button, Modal } from '@mui/material';
import { useState } from 'react';

export default function Picture({ picture, pictures }) {
  const [currentPicture, setCurrentPicture] = useState();
  const [isOpen, setIsOpen] = useState(false);

  function showOverlay(url) {
    setIsOpen(true);
    setCurrentPicture(url);
  }

  const handleClose = () => {
    setIsOpen(false);
  };

  return pictures ? (
    <Box sx={styles.carousel}>
      <Modal open={isOpen} onClose={handleClose}>
        <Box sx={styles.modalContent}>
          <img style={styles.bigPicture} src={currentPicture} alt={currentPicture} />
          <Button variant="outlined" onClick={handleClose} sx={styles.closeButton}>
            Close
          </Button>
        </Box>
      </Modal>
      {pictures.map((picture, i) => (
        <img key={i} style={styles.picture} src={picture} alt={picture} onClick={() => showOverlay(picture)} />
      ))}
    </Box>
  ) : picture && (
    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
      <img style={styles.picture} src={picture} alt={picture} />
    </Box>
  )
}

const styles = {
  carousel: {
    display: 'flex',
    flexDirection: 'row',
    overflowX: 'auto',
    overflowY: 'hidden',
    gap: 2
  },
  picture: {
    maxHeight: 200,
    maxWidth: 200,
    margin: 5,
    borderRadius: '8px',
    objectFit: 'cover',
    cursor: 'pointer',
    transition: 'transform 0.2s',
    '&:hover': {
      transform: 'scale(1.05)'
    }
  },
  bigPicture: {
    maxWidth: '100%',
    maxHeight: '80vh',
    borderRadius: '8px',
    marginBottom: '16px'
  },
  modalContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 2,
    backgroundColor: 'white',
    borderRadius: '8px',
    boxShadow: 24
  },
  closeButton: {
    marginTop: 2
  }
};
